import type { SVGProps } from "react";
export interface StandardCcIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function StandardCcIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: StandardCcIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 7c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v10c0 1.036.84 1.875 1.875 1.875h14c1.035 0 1.874-.84 1.875-1.875zm2.25 10A4.125 4.125 0 0 1 19 21.125H5A4.125 4.125 0 0 1 .875 17V7A4.125 4.125 0 0 1 5 2.875h14A4.125 4.125 0 0 1 23.125 7z"
      />
      <path
        fill={color}
        d="M9.222 13.988a1.126 1.126 0 0 1 2.097.805l-.096.257c-.54 1.262-1.872 2.075-3.223 2.075a3.366 3.366 0 0 1-3.375-3.376V10.25A3.383 3.383 0 0 1 8 6.875c1.35 0 2.684.813 3.223 2.074l.096.258.031.111a1.125 1.125 0 0 1-2.128.693l-.041-.107-.065-.148C8.928 9.418 8.49 9.125 8 9.125c-.62 0-1.125.515-1.125 1.125v3.5c0 .628.496 1.124 1.125 1.124.56 0 1.052-.382 1.18-.777zm8 0a1.126 1.126 0 0 1 2.098.805l-.098.257c-.539 1.262-1.872 2.075-3.223 2.075a3.366 3.366 0 0 1-3.375-3.376V10.25A3.384 3.384 0 0 1 16 6.875c1.441 0 2.863.924 3.321 2.332a1.125 1.125 0 0 1-2.14.697c-.128-.395-.621-.779-1.18-.779-.62 0-1.126.515-1.126 1.125v3.5c0 .628.497 1.124 1.125 1.124.56 0 1.052-.382 1.181-.777z"
      />
    </svg>
  );
}
